import { runtime } from "../../utils/runtimeInjection"
import { parseURL } from "./resolveFramerResourceURL"

const flatten = <T>(arrays: T[] | T[][]): T[] => [].concat.apply([], arrays)

type StringArray = string[]
type ServerURLArguments = StringArray | StringArray[]

function joinPaths(paths: ServerURLArguments): string {
    let res = ""
    for (const path of paths) {
        if (!path) continue
        if (res.length > 0 && !res.endsWith("/")) {
            res += "/"
        }
        if (Array.isArray(path)) {
            res += joinPaths(path)
        } else {
            res += encodeURIComponent(path).replace(/%2F/g, "/")
        }
    }
    return res
}

/**
 * NOT INTERNAL, being exposed from "framer/resources" as `url`
 * @internal
 */
export function serverURL(...paths: ServerURLArguments): string {
    // if only one of the arguments is not empty and is a valid URL
    const notEmptyPaths = flatten(paths).filter(Boolean)
    if (notEmptyPaths.length === 1 && parseURL(notEmptyPaths[0])) {
        return notEmptyPaths[0]
    }
    const path = joinPaths(paths)

    const resolvedAsset = runtime.assetResolver(path, { isFramerResourceURL: true })
    return resolvedAsset || ""
}
